function parcelForceService() {

  let error;

  function isParcelForceCode(trackingCode) {

    if (trackingCode) {

      switch (trackingCode.length) {
        // 9 Characters numbers can only be in the form XX9999999 or 999999999
        case 9:

          if (/[0-9A-Z]{2}[0-9]{7}/ig.test(trackingCode)) {

            return true;

          }

          error = 'INVALID_NINE';
          break;
        case 12:
          // 12 Characters 999999999999 or start with 9826 or start with 9830.
          if (
            (/9826[0-9]{8}/ig.test(trackingCode)) ||
            (/9830[0-9]{8}/ig.test(trackingCode)) ||
            (/[0-9]{12}/ig.test(trackingCode))
          ) {

            return true;

          }

          error = 'INVALID_TWELVE';
          break;
        case 13:
          // Only these formats are valid:
          // 3SXXXX9999999
          // 3E99999999999
          // 8E99999999999
          if (
            (/3S[A-Z]{4}[0-9]{7}/ig.test(trackingCode)) ||
            (/3E[0-9]{11}/ig.test(trackingCode)) ||
            (/8E[0-9]{11}/ig.test(trackingCode))
          ) {

            return true;

          }

          // Only these formats are valid:
          // 99999999999XX
          // XXXX9999999GB
          // 9XXXX99999999
          if (
              (/[0-9]{11}[A-Z]{2}/ig.test(trackingCode)) ||
              (/[A-Z]{4}[0-9]{7}GB/ig.test(trackingCode)) ||
              (/[0-9]{1}[A-Z]{4}[0-9]{8}/ig.test(trackingCode))
            ) {

            return true;

          }

          // NO GB suffix and the following prefixes:
          // CA-CZ, EA-EZ, BA-BZ, PA, ND-NS
          if (/((C[A-Z])|(E[A-Z])|(B[A-Z])|(PA)|(N[D-S]))[0-9]{9}(?!GB)[A-Z]{2}/ig.test(trackingCode)) {

            return 'isPFW';

          }

          // GB suffix and the following prefixes:
          // CK, CP, CU, EA, EB, EC, ED, EE, EH, EK, EU
          if (/((CK)|(CP)|(CU)|(E[A-E])|(EH)|(EK)|(EU))[0-9]{9}GB/ig.test(trackingCode)) {

            return 'isPFW';

          }

          error = 'INVALID_THIRTEEN_PFW';
          break;
        case 14:
          // 14 Characters must be in the format XXXX9999999999 or PB999999999999
          if (
            (/[A-Z]{4}[0-9]{10}/ig.test(trackingCode)) ||
            (/PB[0-9]{12}/ig.test(trackingCode))
          ) {

            return true;

          }

          error = 'INVALID_FOURTEEN';
          break;
        default:
          return false;

      }

    }

    return false;

  }

  function checkPFW(isValidNumber, trackingCode) {

    error = null;

    const isPFW = isParcelForceCode(trackingCode);

    if (isPFW && !error) return 'isPFW';
    if (error) return error;

    return isValidNumber;

  }

  return {
    isParcelForceCode,
    checkPFW
  };

}

export default parcelForceService;



// WEBPACK FOOTER //
// ./src/services/parcelForce.service.js